import React, { useState, useEffect } from "react";
import PersonIcon from "@mui/icons-material/Person";
import "./contact.css";
import axios from "axios";
import { connect } from "react-redux";
import { setDialedNumberInc } from "../../redux/actions/actions";
import {
  BaseUrl,
  VoiceDomainName,
  VoiceDomainNamePure
} from "../../container/BaseUrl/BaseUrl";
import {
  Stack,
  Button,
  Slide,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  Typography,
  Pagination,
} from "@mui/material";
import AddCustomer from "./AddCustomer";
import EditCustomer from "./EditCustomer";
import NoSelectContact from "../../assets/svgtopng/Screenshot.png";
import { toast } from "react-toastify";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
const mapStateToProps = (state) => {
  return { skillset: state.data.skillset };
};
const Contacts = () => {
  const AvcUrl = localStorage.getItem("AvcUrl");
  const [searchvalue, setsearchvalue] = useState("");
  const [contactList, setContactList] = useState([]);
  const [showAddCustomer, setshowAddCustomer] = useState("");
  const [showEditCustomer, setsetshowEditCustomer] = useState("");
  const [selectedUser, setselectedUser] = useState([]);
  const [selectedIndex, setselectedIndex] = useState();
  const [showTab, setshowTab] = useState("Overview");
  const [showUserContactDetail, setshowUserContactDetail] = useState(false);
  const [deleteModalDialog, setDeleteModalDialog] = useState(false);

  const [pagination, setPagination] = useState(0);
  const [page, setPage] = useState(1);
  const handleChange = (event, value) => {
    setPage(value);
  };
  const DeleteDialogClose = () => {
    setDeleteModalDialog(false);
  };
  useEffect(() => {
    listContact();
  }, [page]);

  const listContact = () => {
    axios
      .post(
        BaseUrl + "/users/listcustomer",
        { offset: page == 1 ? 0 : (page - 1) * 7, limit: 7 },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setContactList(res.data.data);
          setPagination(res.data.count);
        }
      })
      .catch((err) => {});
  };

  let randomColors = [
    "#402B3A",
    "#86A7FC",
    "#3468C0",
    "#FF9843",
    "#332941",
    "#3B3486",
    "#864AF9",
    "#F8E559",
    "#1D2B53",
    "#7E2553",
    "#FF004D",
    "#FAEF5D",
    "#365486",
    "#0F1035",
    "#2D3250",
    "#424769",
    "#7077A1",
    "#525CEB",
    "#3D3B40",
    "#B4D4FF",
    "#B4D4FF",
    "#86B6F6",
    "#176B87",
    "#4F6F52",
    "#739072",
    "#52D3D8",
    "#52D3D8",
    "#9BB8CD",
    "#092635",
    "#1B4242",
    "#5C8374",
    "#9EC8B9",
    "#191919",
    "#750E21",
    "#E3651D",
    "#BED754",
    "#DF826C",
    "#161A30",
    "#31304D",
    "#B6BBC4",
    "#FED9ED",
    "#E7BCDE",
    "#402B3A",
    "#86A7FC",
    "#3468C0",
    "#FF9843",
    "#332941",
    "#3B3486",
    "#864AF9",
    "#F8E559",
    "#1D2B53",
    "#7E2553",
    "#FF004D",
    "#FAEF5D",
    "#365486",
    "#0F1035",
    "#2D3250",
    "#424769",
    "#7077A1",
    "#525CEB",
    "#3D3B40",
    "#B4D4FF",
    "#B4D4FF",
    "#86B6F6",
    "#176B87",
    "#4F6F52",
    "#739072",
    "#52D3D8",
    "#52D3D8",
    "#9BB8CD",
    "#092635",
    "#1B4242",
    "#5C8374",
    "#9EC8B9",
    "#191919",
    "#750E21",
    "#E3651D",
    "#BED754",
    "#DF826C",
    "#161A30",
    "#31304D",
    "#B6BBC4",
    "#FED9ED",
    "#E7BCDE",
    "#402B3A",
    "#86A7FC",
    "#3468C0",
    "#FF9843",
    "#332941",
    "#3B3486",
    "#864AF9",
    "#F8E559",
    "#1D2B53",
    "#7E2553",
    "#FF004D",
    "#FAEF5D",
    "#365486",
    "#0F1035",
    "#2D3250",
    "#424769",
    "#7077A1",
    "#525CEB",
    "#3D3B40",
    "#B4D4FF",
    "#B4D4FF",
    "#86B6F6",
    "#176B87",
    "#4F6F52",
    "#739072",
    "#52D3D8",
    "#52D3D8",
    "#9BB8CD",
    "#092635",
    "#1B4242",
    "#5C8374",
    "#9EC8B9",
    "#191919",
    "#750E21",
    "#E3651D",
    "#BED754",
    "#DF826C",
    "#161A30",
    "#31304D",
    "#B6BBC4",
    "#FED9ED",
    "#E7BCDE",
    "#402B3A",
    "#86A7FC",
    "#3468C0",
    "#FF9843",
    "#332941",
    "#3B3486",
    "#864AF9",
    "#F8E559",
    "#1D2B53",
    "#7E2553",
    "#FF004D",
    "#FAEF5D",
    "#365486",
    "#0F1035",
    "#2D3250",
    "#424769",
    "#7077A1",
    "#525CEB",
    "#3D3B40",
    "#B4D4FF",
    "#B4D4FF",
    "#86B6F6",
    "#176B87",
    "#4F6F52",
    "#739072",
    "#52D3D8",
    "#52D3D8",
    "#9BB8CD",
    "#092635",
    "#1B4242",
    "#5C8374",
    "#9EC8B9",
    "#191919",
    "#750E21",
    "#E3651D",
    "#BED754",
    "#DF826C",
    "#161A30",
    "#31304D",
    "#B6BBC4",
    "#FED9ED",
    "#E7BCDE",
    "#402B3A",
    "#86A7FC",
    "#3468C0",
    "#FF9843",
    "#332941",
    "#3B3486",
    "#864AF9",
    "#F8E559",
    "#1D2B53",
    "#7E2553",
    "#FF004D",
    "#FAEF5D",
    "#365486",
    "#0F1035",
    "#2D3250",
    "#424769",
    "#7077A1",
    "#525CEB",
    "#3D3B40",
    "#B4D4FF",
    "#B4D4FF",
    "#86B6F6",
    "#176B87",
    "#4F6F52",
    "#739072",
    "#52D3D8",
    "#52D3D8",
    "#9BB8CD",
    "#092635",
    "#1B4242",
    "#5C8374",
    "#9EC8B9",
    "#191919",
    "#750E21",
    "#E3651D",
    "#BED754",
    "#DF826C",
    "#161A30",
    "#31304D",
    "#B6BBC4",
    "#FED9ED",
    "#E7BCDE",
    "#402B3A",
    "#86A7FC",
    "#3468C0",
    "#FF9843",
    "#332941",
    "#3B3486",
    "#864AF9",
    "#F8E559",
    "#1D2B53",
    "#7E2553",
    "#FF004D",
    "#FAEF5D",
    "#365486",
    "#0F1035",
    "#2D3250",
    "#424769",
    "#7077A1",
    "#525CEB",
    "#3D3B40",
    "#B4D4FF",
    "#B4D4FF",
    "#86B6F6",
    "#176B87",
    "#4F6F52",
    "#739072",
    "#52D3D8",
    "#52D3D8",
    "#9BB8CD",
    "#092635",
    "#1B4242",
    "#5C8374",
    "#9EC8B9",
    "#191919",
    "#750E21",
    "#E3651D",
    "#BED754",
    "#DF826C",
    "#161A30",
    "#31304D",
    "#B6BBC4",
    "#FED9ED",
    "#E7BCDE",
    "#402B3A",
    "#86A7FC",
    "#3468C0",
    "#FF9843",
    "#332941",
    "#3B3486",
    "#864AF9",
    "#F8E559",
    "#1D2B53",
    "#7E2553",
    "#FF004D",
    "#FAEF5D",
    "#365486",
    "#0F1035",
    "#2D3250",
    "#424769",
    "#7077A1",
    "#525CEB",
    "#3D3B40",
    "#B4D4FF",
    "#B4D4FF",
    "#86B6F6",
    "#176B87",
    "#4F6F52",
    "#739072",
    "#52D3D8",
    "#52D3D8",
    "#9BB8CD",
    "#092635",
    "#1B4242",
    "#5C8374",
    "#9EC8B9",
    "#191919",
    "#750E21",
    "#E3651D",
    "#BED754",
    "#DF826C",
    "#161A30",
    "#31304D",
    "#B6BBC4",
    "#FED9ED",
    "#E7BCDE",
    "#402B3A",
    "#86A7FC",
    "#3468C0",
    "#FF9843",
    "#332941",
    "#3B3486",
    "#864AF9",
    "#F8E559",
    "#1D2B53",
    "#7E2553",
    "#FF004D",
    "#FAEF5D",
    "#365486",
    "#0F1035",
    "#2D3250",
    "#424769",
    "#7077A1",
    "#525CEB",
    "#3D3B40",
    "#B4D4FF",
    "#B4D4FF",
    "#86B6F6",
    "#176B87",
    "#4F6F52",
    "#739072",
    "#52D3D8",
    "#52D3D8",
    "#9BB8CD",
    "#092635",
    "#1B4242",
    "#5C8374",
    "#9EC8B9",
    "#191919",
    "#750E21",
    "#E3651D",
    "#BED754",
    "#DF826C",
    "#161A30",
    "#31304D",
    "#B6BBC4",
    "#FED9ED",
    "#E7BCDE",
    "#402B3A",
    "#86A7FC",
    "#3468C0",
    "#FF9843",
    "#332941",
    "#3B3486",
    "#864AF9",
    "#F8E559",
    "#1D2B53",
    "#7E2553",
    "#FF004D",
    "#FAEF5D",
    "#365486",
    "#0F1035",
    "#2D3250",
    "#424769",
    "#7077A1",
    "#525CEB",
    "#3D3B40",
    "#B4D4FF",
    "#B4D4FF",
    "#86B6F6",
    "#176B87",
    "#4F6F52",
    "#739072",
    "#52D3D8",
    "#52D3D8",
    "#9BB8CD",
    "#092635",
    "#1B4242",
    "#5C8374",
    "#9EC8B9",
    "#191919",
    "#750E21",
    "#E3651D",
    "#BED754",
    "#DF826C",
    "#161A30",
    "#31304D",
    "#B6BBC4",
    "#FED9ED",
    "#E7BCDE",
    "#402B3A",
    "#86A7FC",
    "#3468C0",
    "#FF9843",
    "#332941",
    "#3B3486",
    "#864AF9",
    "#F8E559",
    "#1D2B53",
    "#7E2553",
    "#FF004D",
    "#FAEF5D",
    "#365486",
    "#0F1035",
    "#2D3250",
    "#424769",
    "#7077A1",
    "#525CEB",
    "#3D3B40",
    "#B4D4FF",
    "#B4D4FF",
    "#86B6F6",
    "#176B87",
    "#4F6F52",
    "#739072",
    "#52D3D8",
    "#52D3D8",
    "#9BB8CD",
    "#092635",
    "#1B4242",
    "#5C8374",
    "#9EC8B9",
    "#191919",
    "#750E21",
    "#E3651D",
    "#BED754",
    "#DF826C",
    "#161A30",
    "#31304D",
    "#B6BBC4",
    "#FED9ED",
    "#E7BCDE",
    "#402B3A",
    "#86A7FC",
    "#3468C0",
    "#FF9843",
    "#332941",
    "#3B3486",
    "#864AF9",
    "#F8E559",
    "#1D2B53",
    "#7E2553",
    "#FF004D",
    "#FAEF5D",
    "#365486",
    "#0F1035",
    "#2D3250",
    "#424769",
    "#7077A1",
    "#525CEB",
    "#3D3B40",
    "#B4D4FF",
    "#B4D4FF",
    "#86B6F6",
    "#176B87",
    "#4F6F52",
    "#739072",
    "#52D3D8",
    "#52D3D8",
    "#9BB8CD",
    "#092635",
    "#1B4242",
    "#5C8374",
    "#9EC8B9",
    "#191919",
    "#750E21",
    "#E3651D",
    "#BED754",
    "#DF826C",
    "#161A30",
    "#31304D",
    "#B6BBC4",
    "#FED9ED",
    "#E7BCDE",
    "#402B3A",
    "#86A7FC",
    "#3468C0",
    "#FF9843",
    "#332941",
    "#3B3486",
    "#864AF9",
    "#F8E559",
    "#1D2B53",
    "#7E2553",
    "#FF004D",
    "#FAEF5D",
    "#365486",
    "#0F1035",
    "#2D3250",
    "#424769",
    "#7077A1",
    "#525CEB",
    "#3D3B40",
    "#B4D4FF",
    "#B4D4FF",
    "#86B6F6",
    "#176B87",
    "#4F6F52",
    "#739072",
    "#52D3D8",
    "#52D3D8",
    "#9BB8CD",
    "#092635",
    "#1B4242",
    "#5C8374",
    "#9EC8B9",
    "#191919",
    "#750E21",
    "#E3651D",
    "#BED754",
    "#DF826C",
    "#161A30",
    "#31304D",
    "#B6BBC4",
    "#FED9ED",
    "#E7BCDE",
    "#402B3A",
    "#86A7FC",
    "#3468C0",
    "#FF9843",
    "#332941",
    "#3B3486",
    "#864AF9",
    "#F8E559",
    "#1D2B53",
    "#7E2553",
    "#FF004D",
    "#FAEF5D",
    "#365486",
    "#0F1035",
    "#2D3250",
    "#424769",
    "#7077A1",
    "#525CEB",
    "#3D3B40",
    "#B4D4FF",
    "#B4D4FF",
    "#86B6F6",
    "#176B87",
    "#4F6F52",
    "#739072",
    "#52D3D8",
    "#52D3D8",
    "#9BB8CD",
    "#092635",
    "#1B4242",
    "#5C8374",
    "#9EC8B9",
    "#191919",
    "#750E21",
    "#E3651D",
    "#BED754",
    "#DF826C",
    "#161A30",
    "#31304D",
    "#B6BBC4",
    "#FED9ED",
    "#E7BCDE",
    "#402B3A",
    "#86A7FC",
    "#3468C0",
    "#FF9843",
    "#332941",
    "#3B3486",
    "#864AF9",
    "#F8E559",
    "#1D2B53",
    "#7E2553",
    "#FF004D",
    "#FAEF5D",
    "#365486",
    "#0F1035",
    "#2D3250",
    "#424769",
    "#7077A1",
    "#525CEB",
    "#3D3B40",
    "#B4D4FF",
    "#B4D4FF",
    "#86B6F6",
    "#176B87",
    "#4F6F52",
    "#739072",
    "#52D3D8",
    "#52D3D8",
    "#9BB8CD",
    "#092635",
    "#1B4242",
    "#5C8374",
    "#9EC8B9",
    "#191919",
    "#750E21",
    "#E3651D",
    "#BED754",
    "#DF826C",
    "#161A30",
    "#31304D",
    "#B6BBC4",
    "#FED9ED",
    "#E7BCDE",
    "#402B3A",
    "#86A7FC",
    "#3468C0",
    "#FF9843",
    "#332941",
    "#3B3486",
    "#864AF9",
    "#F8E559",
    "#1D2B53",
    "#7E2553",
    "#FF004D",
    "#FAEF5D",
    "#365486",
    "#0F1035",
    "#2D3250",
    "#424769",
    "#7077A1",
    "#525CEB",
    "#3D3B40",
    "#B4D4FF",
    "#B4D4FF",
    "#86B6F6",
    "#176B87",
    "#4F6F52",
    "#739072",
    "#52D3D8",
    "#52D3D8",
    "#9BB8CD",
    "#092635",
    "#1B4242",
    "#5C8374",
    "#9EC8B9",
    "#191919",
    "#750E21",
    "#E3651D",
    "#BED754",
    "#DF826C",
    "#161A30",
    "#31304D",
    "#B6BBC4",
    "#FED9ED",
    "#E7BCDE",
    "#402B3A",
    "#86A7FC",
    "#3468C0",
    "#FF9843",
    "#332941",
    "#3B3486",
    "#864AF9",
    "#F8E559",
    "#1D2B53",
    "#7E2553",
    "#FF004D",
    "#FAEF5D",
    "#365486",
    "#0F1035",
    "#2D3250",
    "#424769",
    "#7077A1",
    "#525CEB",
    "#3D3B40",
    "#B4D4FF",
    "#B4D4FF",
    "#86B6F6",
    "#176B87",
    "#4F6F52",
    "#739072",
    "#52D3D8",
    "#52D3D8",
    "#9BB8CD",
    "#092635",
    "#1B4242",
    "#5C8374",
    "#9EC8B9",
    "#191919",
    "#750E21",
    "#E3651D",
    "#BED754",
    "#DF826C",
    "#161A30",
    "#31304D",
    "#B6BBC4",
    "#FED9ED",
    "#E7BCDE",
    "#402B3A",
    "#86A7FC",
    "#3468C0",
    "#FF9843",
    "#332941",
    "#3B3486",
    "#864AF9",
    "#F8E559",
    "#1D2B53",
    "#7E2553",
    "#FF004D",
    "#FAEF5D",
    "#365486",
    "#0F1035",
    "#2D3250",
    "#424769",
    "#7077A1",
    "#525CEB",
    "#3D3B40",
    "#B4D4FF",
    "#B4D4FF",
    "#86B6F6",
    "#176B87",
    "#4F6F52",
    "#739072",
    "#52D3D8",
    "#52D3D8",
    "#9BB8CD",
    "#092635",
    "#1B4242",
    "#5C8374",
    "#9EC8B9",
    "#191919",
    "#750E21",
    "#E3651D",
    "#BED754",
    "#DF826C",
    "#161A30",
    "#31304D",
    "#B6BBC4",
    "#FED9ED",
    "#E7BCDE",
    "#402B3A",
    "#86A7FC",
    "#3468C0",
    "#FF9843",
    "#332941",
    "#3B3486",
    "#864AF9",
    "#F8E559",
    "#1D2B53",
    "#7E2553",
    "#FF004D",
    "#FAEF5D",
    "#365486",
    "#0F1035",
    "#2D3250",
    "#424769",
    "#7077A1",
    "#525CEB",
    "#3D3B40",
    "#B4D4FF",
    "#B4D4FF",
    "#86B6F6",
    "#176B87",
    "#4F6F52",
    "#739072",
    "#52D3D8",
    "#52D3D8",
    "#9BB8CD",
    "#092635",
    "#1B4242",
    "#5C8374",
    "#9EC8B9",
    "#191919",
    "#750E21",
    "#E3651D",
    "#BED754",
    "#DF826C",
    "#161A30",
    "#31304D",
    "#B6BBC4",
    "#FED9ED",
    "#E7BCDE",
    "#402B3A",
    "#86A7FC",
    "#3468C0",
    "#FF9843",
    "#332941",
    "#3B3486",
    "#864AF9",
    "#F8E559",
    "#1D2B53",
    "#7E2553",
    "#FF004D",
    "#FAEF5D",
    "#365486",
    "#0F1035",
    "#2D3250",
    "#424769",
    "#7077A1",
    "#525CEB",
    "#3D3B40",
    "#B4D4FF",
    "#B4D4FF",
    "#86B6F6",
    "#176B87",
    "#4F6F52",
    "#739072",
    "#52D3D8",
    "#52D3D8",
    "#9BB8CD",
    "#092635",
    "#1B4242",
    "#5C8374",
    "#9EC8B9",
    "#191919",
    "#750E21",
    "#E3651D",
    "#BED754",
    "#DF826C",
    "#161A30",
    "#31304D",
    "#B6BBC4",
    "#FED9ED",
    "#E7BCDE",
    "#402B3A",
    "#86A7FC",
    "#3468C0",
    "#FF9843",
    "#332941",
    "#3B3486",
    "#864AF9",
    "#F8E559",
    "#1D2B53",
    "#7E2553",
    "#FF004D",
    "#FAEF5D",
    "#365486",
    "#0F1035",
    "#2D3250",
    "#424769",
    "#7077A1",
    "#525CEB",
    "#3D3B40",
    "#B4D4FF",
    "#B4D4FF",
    "#86B6F6",
    "#176B87",
    "#4F6F52",
    "#739072",
    "#52D3D8",
    "#52D3D8",
    "#9BB8CD",
    "#092635",
    "#1B4242",
    "#5C8374",
    "#9EC8B9",
    "#191919",
    "#750E21",
    "#E3651D",
    "#BED754",
    "#DF826C",
    "#161A30",
    "#31304D",
    "#B6BBC4",
    "#FED9ED",
    "#E7BCDE",
    "#402B3A",
    "#86A7FC",
    "#3468C0",
    "#FF9843",
    "#332941",
    "#3B3486",
    "#864AF9",
    "#F8E559",
    "#1D2B53",
    "#7E2553",
    "#FF004D",
    "#FAEF5D",
    "#365486",
    "#0F1035",
    "#2D3250",
    "#424769",
    "#7077A1",
    "#525CEB",
    "#3D3B40",
    "#B4D4FF",
    "#B4D4FF",
    "#86B6F6",
    "#176B87",
    "#4F6F52",
    "#739072",
    "#52D3D8",
    "#52D3D8",
    "#9BB8CD",
    "#092635",
    "#1B4242",
    "#5C8374",
    "#9EC8B9",
    "#191919",
    "#750E21",
    "#E3651D",
    "#BED754",
    "#DF826C",
    "#161A30",
    "#31304D",
    "#B6BBC4",
    "#FED9ED",
    "#E7BCDE",
    "#402B3A",
    "#86A7FC",
    "#3468C0",
    "#FF9843",
    "#332941",
    "#3B3486",
    "#864AF9",
    "#F8E559",
    "#1D2B53",
    "#7E2553",
    "#FF004D",
    "#FAEF5D",
    "#365486",
    "#0F1035",
    "#2D3250",
    "#424769",
    "#7077A1",
    "#525CEB",
    "#3D3B40",
    "#B4D4FF",
    "#B4D4FF",
    "#86B6F6",
    "#176B87",
    "#4F6F52",
    "#739072",
    "#52D3D8",
    "#52D3D8",
    "#9BB8CD",
    "#092635",
    "#1B4242",
    "#5C8374",
    "#9EC8B9",
    "#191919",
    "#750E21",
    "#E3651D",
    "#BED754",
    "#DF826C",
    "#161A30",
    "#31304D",
    "#B6BBC4",
    "#FED9ED",
    "#E7BCDE",
    "#402B3A",
    "#86A7FC",
    "#3468C0",
    "#FF9843",
    "#332941",
    "#3B3486",
    "#864AF9",
    "#F8E559",
    "#1D2B53",
    "#7E2553",
    "#FF004D",
    "#FAEF5D",
    "#365486",
    "#0F1035",
    "#2D3250",
    "#424769",
    "#7077A1",
    "#525CEB",
    "#3D3B40",
    "#B4D4FF",
    "#B4D4FF",
    "#86B6F6",
    "#176B87",
    "#4F6F52",
    "#739072",
    "#52D3D8",
    "#52D3D8",
    "#9BB8CD",
    "#092635",
    "#1B4242",
    "#5C8374",
    "#9EC8B9",
    "#191919",
    "#750E21",
    "#E3651D",
    "#BED754",
    "#DF826C",
    "#161A30",
    "#31304D",
    "#B6BBC4",
    "#FED9ED",
    "#E7BCDE",
    "#402B3A",
    "#86A7FC",
    "#3468C0",
    "#FF9843",
    "#332941",
    "#3B3486",
    "#864AF9",
    "#F8E559",
    "#1D2B53",
    "#7E2553",
    "#FF004D",
    "#FAEF5D",
    "#365486",
    "#0F1035",
    "#2D3250",
    "#424769",
    "#7077A1",
    "#525CEB",
    "#3D3B40",
    "#B4D4FF",
    "#B4D4FF",
    "#86B6F6",
    "#176B87",
    "#4F6F52",
    "#739072",
    "#52D3D8",
    "#52D3D8",
    "#9BB8CD",
    "#092635",
    "#1B4242",
    "#5C8374",
    "#9EC8B9",
    "#191919",
    "#750E21",
    "#E3651D",
    "#BED754",
    "#DF826C",
    "#161A30",
    "#31304D",
    "#B6BBC4",
    "#FED9ED",
    "#E7BCDE",
    "#402B3A",
    "#86A7FC",
    "#3468C0",
    "#FF9843",
    "#332941",
    "#3B3486",
    "#864AF9",
    "#F8E559",
    "#1D2B53",
    "#7E2553",
    "#FF004D",
    "#FAEF5D",
    "#365486",
    "#0F1035",
    "#2D3250",
    "#424769",
    "#7077A1",
    "#525CEB",
    "#3D3B40",
    "#B4D4FF",
    "#B4D4FF",
    "#86B6F6",
    "#176B87",
    "#4F6F52",
    "#739072",
    "#52D3D8",
    "#52D3D8",
    "#9BB8CD",
    "#092635",
    "#1B4242",
    "#5C8374",
    "#9EC8B9",
    "#191919",
    "#750E21",
    "#E3651D",
    "#BED754",
    "#DF826C",
    "#161A30",
    "#31304D",
    "#B6BBC4",
    "#FED9ED",
    "#E7BCDE",
    "#402B3A",
    "#86A7FC",
    "#3468C0",
    "#FF9843",
    "#332941",
    "#3B3486",
    "#864AF9",
    "#F8E559",
    "#1D2B53",
    "#7E2553",
    "#FF004D",
    "#FAEF5D",
    "#365486",
    "#0F1035",
    "#2D3250",
    "#424769",
    "#7077A1",
    "#525CEB",
    "#3D3B40",
    "#B4D4FF",
    "#B4D4FF",
    "#86B6F6",
    "#176B87",
    "#4F6F52",
    "#739072",
    "#52D3D8",
    "#52D3D8",
    "#9BB8CD",
    "#092635",
    "#1B4242",
    "#5C8374",
    "#9EC8B9",
    "#191919",
    "#750E21",
    "#E3651D",
    "#BED754",
    "#DF826C",
    "#161A30",
    "#31304D",
    "#B6BBC4",
    "#FED9ED",
    "#E7BCDE",
    "#402B3A",
    "#86A7FC",
    "#3468C0",
    "#FF9843",
    "#332941",
    "#3B3486",
    "#864AF9",
    "#F8E559",
    "#1D2B53",
    "#7E2553",
    "#FF004D",
    "#FAEF5D",
    "#365486",
    "#0F1035",
    "#2D3250",
    "#424769",
    "#7077A1",
    "#525CEB",
    "#3D3B40",
    "#B4D4FF",
    "#B4D4FF",
    "#86B6F6",
    "#176B87",
    "#4F6F52",
    "#739072",
    "#52D3D8",
    "#52D3D8",
    "#9BB8CD",
    "#092635",
    "#1B4242",
    "#5C8374",
    "#9EC8B9",
    "#191919",
    "#750E21",
    "#E3651D",
    "#BED754",
    "#DF826C",
    "#161A30",
    "#31304D",
    "#B6BBC4",
    "#FED9ED",
    "#E7BCDE",
  ];

  const makeCall = (calledNo, type, id) => {
    localStorage.setItem("callActivate", "true");
    let agentLoginTerminalId = localStorage.getItem("agentLoginTerminalId");
    props.setDialedNumberInc(calledNo);

    axios
      .post(
        AvcUrl +
          `/voice/terminal/${agentLoginTerminalId}/createContact/sip:${agentLoginTerminalId}@${localStorage.getItem("TenantId")=='788205e1-6116-4c09-904a-5b641d09de0f'?VoiceDomainNamePure:VoiceDomainName}/sip:${calledNo}@${localStorage.getItem("TenantId")=='788205e1-6116-4c09-904a-5b641d09de0f'?VoiceDomainNamePure:VoiceDomainName}`,
        {},
        {
          headers: {
            ssoToken: localStorage.getItem("ssoToken"),
          },
        }
      )
      .then((res) => {
        if (res.data.statusCode == 500) {
          toast.warn(res.data.status, {
            position: "top-right",
            autoClose: 500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "light",
          });
        } else if (res.data.status == "OK") {
          localStorage.setItem("type", type);
          localStorage.setItem("ContactVoiceId", id);
        }
      })
      .catch((err) => {});
  };

  return (
    <>
      <div class="dashboard">
        <Stack
          direction="row"
          justifyContent="end"
          sx={{ paddingRight: "11px" }}
        >
          <Button
            size="small"
            variant="contained"
            startIcon={<PersonIcon />}
            onClick={() => {
              setshowAddCustomer("sidebar_filter active-r");
            }}
          >
            Add Customer
          </Button>
        </Stack>
        <div class="container-fluid">
          <div class="wapper_sub">
            <div class="sub_wapper">
              <div class="container-fluid card mt-1 border-0 fixed-table-card vh-85">
                <div class="row classic-view">
                  <div class="col-3 customer_main newcust-main pe-0 ps-0">
                    <div class="cust_hed-new pt-1 pb-5 border-end">
                      <div class="cont-search p-2  mb-1 border-bottom">
                        <div class="nav-item w-100 min-33h ">
                          <form class="rounded position-relative">
                            <input
                              autocomplete="off"
                              class="rounded-0 form-control fs-14 ps-5 bg-light"
                              type="search"
                              name="content"
                              placeholder="Search Customer"
                              aria-label="Search"
                              onChange={(e) => {
                                setsearchvalue(e.target.value);
                              }}
                            />
                            <button
                              class="d-flex-p btn bg-transparent px-2 py-0 position-absolute top-50 start-0 min-33h border-0 translate-middle-y"
                              type="submit"
                            >
                              <i class="fa-solid fa-magnifying-glass"></i>
                            </button>
                          </form>
                        </div>
                      </div>

                      <div class="contacts-list mt-1 p-1">
                        {contactList.length > 0
                          ? contactList
                              .filter((value) => {
                                return value.username
                                  .toLowerCase()
                                  .includes(searchvalue.toLowerCase());
                              })

                              .map((user, index) => {
                                return (
                                  <div
                                    key={user.id}
                                    class={
                                      selectedUser.id == user.id
                                        ? "contact active"
                                        : "contact"
                                    }
                                    onClick={() => {
                                      setselectedUser(user);
                                      setshowUserContactDetail(true);
                                      setselectedIndex(index);
                                    }}
                                  >
                                    <div class="d-flex p-1 justify-content-start align-items-center">
                                      <div
                                        class="animate__animated animate__slideInUp ticket_round rounded-circle me-3"
                                        style={{
                                          backgroundColor: randomColors[index],
                                        }}
                                      >
                                        {user.username
                                          .slice(0, 2)
                                          .toUpperCase()}
                                      </div>
                                      <div class="animate__animated animate__slideInUp">
                                        <div class="cont-name">
                                          {user.username.toUpperCase()}
                                        </div>
                                        <div class="text-muted cont-email">
                                          <i class="fa-solid fa-phone me-1 fs-10"></i>
                                          {user.phonenumber}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                          : "No Contact"}
                      </div>
                      <div className="card-footer rounded-0 d-flex align-item-center justify-content-end align-items-center">
                        <Pagination
                          count={Math.ceil(pagination / 7)}
                          page={page}
                          onChange={handleChange}
                          hidePrevButton
                          hideNextButton
                          color="primary"
                        />
                      </div>
                    </div>
                  </div>

                  {showUserContactDetail ? (
                    <div class="col-9 px-0">
                      <div class="cont-details-main">
                        <div class="cont-details-hed border-bottom py-0">
                          <div class="d-flex p-1 justify-content-start align-items-center">
                            <div>
                              <div
                                class="ticket_round rounded-circle me-3"
                                style={{
                                  backgroundColor: randomColors[selectedIndex],
                                  fontSize: "18px",
                                }}
                              >
                                {selectedUser.username
                                  .slice(0, 2)
                                  .toUpperCase()}
                              </div>
                            </div>
                            <div class="cont-details-n cont-details-hed w-100">
                              <div class="d-flex justify-content-between">
                                <div class="fw-bold cont-name">
                                  {selectedUser.username.toUpperCase()}
                                </div>

                                <div class="r_action">
                                  <div
                                    class="btn-group"
                                    role="group"
                                    aria-label="Basic outlined example"
                                  >
                                    <button
                                      type="button"
                                      class="btn btn-outline-select btn-sm round-0"
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="bottom"
                                      data-bs-title="Edit"
                                      style={{
                                        borderRadius: "8px",
                                        backgroundColor: "#1473E6",
                                        color: "#FFFF",
                                        boxShadow:
                                          "rgba(0, 0, 0, 0.4) -6px 8px 6px -3px inset",
                                      }}
                                      onClick={() => {
                                        makeCall(selectedUser.phonenumber);
                                      }}
                                    >
                                      <i class="fa-solid fa-phone"></i>
                                    </button>

                                    <button
                                      type="button"
                                      class="btn btn-outline-select btn-sm round-0 mx-1"
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="bottom"
                                      data-bs-title="Edit"
                                      onClick={() => {}}
                                      style={{
                                        borderRadius: "8px",
                                        backgroundColor: "#25D366",
                                        color: "#FFFF",
                                        boxShadow:
                                          "rgba(0, 0, 0, 0.4) -6px 8px 6px -3px inset",
                                      }}
                                    >
                                      <i class="fa-brands fa-whatsapp"></i>
                                    </button>

                                    <button
                                      type="button"
                                      class="btn btn-outline-select btn-sm round-0"
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="bottom"
                                      data-bs-title="Edit"
                                      onClick={() => {}}
                                      style={{
                                        borderRadius: "8px",
                                        boxShadow:
                                          "rgba(0, 0, 0, 0.4) -6px 8px 6px -3px inset",
                                      }}
                                    >
                                      <i class="fa-regular fa-circle-up"></i>
                                    </button>

                                    <button
                                      type="button"
                                      class="btn btn-outline-select btn-sm round-0 mx-1"
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="bottom"
                                      data-bs-title="Edit"
                                      onClick={() => {
                                        setsetshowEditCustomer(
                                          "sidebar_filter active-r"
                                        );
                                      }}
                                      style={{
                                        borderRadius: "8px",
                                        boxShadow:
                                          "rgba(0, 0, 0, 0.4) -6px 8px 6px -3px inset",
                                      }}
                                    >
                                      <i class="fa-solid fa-pen-to-square"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>

                              <div class="d-flex">
                                <div class="text-muted cont-email me-3 fs-13">
                                  <i class="fa-solid fa-envelope me-2 text-muted"></i>
                                  {selectedUser.email}
                                </div>
                                <div class="text-muted cont-email fs-13">
                                  <i class="fa-solid fa-phone me-2"></i>
                                  {selectedUser.phonenumber}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="cont-detail-sub p-3">
                          <ul
                            class="nav nav-pills mb-3"
                            id="pills-tab"
                            role="tablist"
                          >
                            <li class="nav-item" role="presentation">
                              <button
                                class="rounded-0 nav-link"
                                style={{
                                  backgroundColor:
                                    showTab == "Overview"
                                      ? randomColors[selectedIndex]
                                      : "",
                                  color:
                                    showTab == "Overview" ? "#ffff" : "#1976D2",
                                }}
                                id="pills-home-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-home"
                                type="button"
                                role="tab"
                                aria-controls="pills-home"
                                aria-selected="true"
                                onClick={() => {
                                  setshowTab("Overview");
                                }}
                              >
                                Overview
                              </button>
                            </li>
                            <li class="nav-item" role="presentation">
                              <button
                                class="rounded-0 nav-link"
                                style={{
                                  backgroundColor:
                                    showTab == "Ticket"
                                      ? randomColors[selectedIndex]
                                      : "",
                                  color:
                                    showTab == "Ticket" ? "#ffff" : "#1976D2",
                                }}
                                id="pills-profile-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-profile"
                                aria-controls="pills-profile"
                                type="button"
                                role="tab"
                                aria-selected="false"
                                onClick={() => {
                                  setshowTab("Ticket");
                                }}
                              >
                                Ticket details
                              </button>
                            </li>
                          </ul>

                          <div class="tab-content" id="pills-tabContent">
                            <div
                              class={
                                showTab == "Overview"
                                  ? "tab-pane fade show active"
                                  : "tab-pane fade show"
                              }
                              id="pills-home"
                              role="tabpanel"
                              aria-labelledby="pills-home-tab"
                            >
                              <div class="cust_view_modal">
                                <div class="row row-cols-3 p-3">
                                  <div class="mb-3 col d-flex align-items-center justify-content-start animate__animated animate__slideInUp">
                                    <div class="cust_icon col-3 bg-white">
                                      <i class="fa-solid fa-user color_b"></i>
                                    </div>
                                    <div class="cust_details_new ps-3 col-9">
                                      <p class="form-label small text-break">
                                        First Name
                                      </p>
                                      <p class="text-break mb-0">
                                        {selectedUser.username}
                                      </p>
                                    </div>
                                  </div>
                                  <div class="mb-3 col d-flex align-items-center justify-content-start animate__animated animate__slideInUp">
                                    <div class="cust_icon col-3 bg-white">
                                      <i class="fa-solid fa-mobile color_b"></i>
                                    </div>
                                    <div class="cust_details_new ps-3 col-9">
                                      <p class="form-label small text-break">
                                        Mobile Number
                                      </p>
                                      <p class="text-break mb-0">
                                        {selectedUser.phonenumber}
                                      </p>
                                    </div>
                                  </div>
                                  <div class="mb-3 col d-flex align-items-center justify-content-start animate__animated animate__slideInUp">
                                    <div class="cust_icon col-3 bg-white">
                                      <i class="fa-solid fa-earth-americas color_b"></i>
                                    </div>
                                    <div class="cust_details_new ps-3 col-9">
                                      <p class="form-label small text-break">
                                        Country
                                      </p>
                                      <p class="text-break mb-0">
                                        {selectedUser.address}
                                      </p>
                                    </div>
                                  </div>
                                  <div class="mb-3 col d-flex align-items-center justify-content-start animate__animated animate__slideInUp">
                                    <div class="cust_icon col-3 bg-white">
                                      <i class="fa-solid fa-phone  color_b"></i>
                                    </div>
                                    <div class="cust_details_new ps-3 col-9">
                                      <p class="form-label small text-break">
                                        Secondary Number
                                      </p>
                                      <p class="text-break mb-0">{"-"}</p>
                                    </div>
                                  </div>
                                  <div class="mb-3 col d-flex align-items-center justify-content-start animate__animated animate__slideInUp">
                                    <div class="cust_icon col-3 bg-white">
                                      <i class="fa-solid fa-envelope color_b"></i>
                                    </div>
                                    <div class="cust_details_new ps-3 col-9">
                                      <p class="form-label small text-break">
                                        Email
                                      </p>
                                      <p class="text-break mb-0">
                                        {selectedUser.email}
                                      </p>
                                    </div>
                                  </div>
                                  <div class="mb-3 col d-flex align-items-center justify-content-start animate__animated animate__slideInUp">
                                    <div class="cust_icon col-3 bg-white">
                                      <i class="fa-solid fa-address-book  color_b"></i>
                                    </div>
                                    <div class="cust_details_new ps-3 col-9">
                                      <p class="form-label small text-break">
                                        Customer Address
                                      </p>
                                      <p class="text-break mb-0">
                                        {selectedUser.address}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              class={
                                showTab == "Ticket"
                                  ? "tab-pane fade show active"
                                  : "tab-pane fade show"
                              }
                              id="pills-profile"
                              role="tabpanel"
                              aria-labelledby="pills-profile-tab"
                            >
                              <div class="cust_view_modal customer-ticket animate__animated animate__slideInUp">
                                <div class="row">
                                  <div class="tickt-table container-fluid table-responsive vh-46">
                                    <table class="table table-sm table-striped table-hover table-ticket-cust align-middle table-fixed  vhm-61">
                                      <thead>
                                        <tr>
                                          <th scope="col">Complaint</th>
                                          <th scope="col">Facility</th>
                                          <th scope="col">Department</th>
                                          <th scope="col">TicketID</th>
                                          <th scope="col">Status</th>
                                          <th scope="col">Priority</th>
                                          <th scope="col">Comments</th>
                                          <th scope="col">Created Time</th>
                                          <th scope="col">Action</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td>Lorem ipsum dolor sit amet</td>
                                          <td>Lorem ipsum dolor sit amet</td>
                                          <td>Lorem ipsum dolor sit amet</td>
                                          <td>Lorem ipsum dolor sit amet</td>
                                          <td>Lorem ipsum dolor sit amet</td>
                                          <td>Lorem ipsum dolor sit amet</td>
                                          <td>Lorem ipsum dolor sit amet</td>
                                          <td>Lorem ipsum dolor sit amet</td>
                                          <td>Lorem ipsum dolor sit amet</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div class="col-9 px-0">
                        <div
                          class="cont-details-main"
                          style={{
                            justifyContent: "center",
                            display: "flex",
                            alignItems: "center",
                            height: "100%",
                          }}
                        >
                          <img
                            src={NoSelectContact}
                            alt="pic"
                            style={{ width: "450px" }}
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddCustomer
        showAddCustomer={showAddCustomer}
        setshowAddCustomer={setshowAddCustomer}
        listContact={listContact}
      />
      <EditCustomer
        showEditCustomer={showEditCustomer}
        setsetshowEditCustomer={setsetshowEditCustomer}
        listContact={listContact}
        selectedUser={selectedUser}
      />

      <Dialog
        open={deleteModalDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={DeleteDialogClose}
        aria-describedby="alert-dialog-slide-description"
        sx={{
          "& .MuiPaper-root": {
            borderRadius: 5,
            padding: 1,
            top: -100,
          },

          backgroundColor: "rgb(0 0 0 / 65%)",
        }}
      >
        <DialogTitle
          variant="subtitle2"
          sx={{ fontSize: "16px", fontWeight: 600 }}
        >
          CONFERMATION
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <Typography variant="subtitle1">
              Are You Sure You Want To Delete This Contact
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" size="small">
            CONFIRM
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default connect(mapStateToProps, { setDialedNumberInc })(Contacts);
